import { RFQCancelButton } from "#/components/RFQCancelButton/RFQCancelButton";
import { type RFQResponseState } from "#/services/kyan/kyan.types";
import { useAccount } from "#/store/wallet/account/account";
import { isEqualAddress } from "#/utils/isEqualAddress";

import { RfqFillButton } from "./components/RfqFillButton/RfqFillButton";

export interface RfqResponseActionProps {
  response: RFQResponseState;
}

export const RfqResponseAction: React.FC<RfqResponseActionProps> = ({
  response,
}) => {
  const { account } = useAccount();

  if (isEqualAddress(account, response.maker)) {
    return <RFQCancelButton response={response} />;
  }

  if (isEqualAddress(account, response.taker)) {
    return <RfqFillButton response={response} />;
  }

  return null;
};
